<template>
  <div class="produse-view">
    <DxTabs
      :data-source="tabs"
      :selected-index="selectedTabIndex"
      item-template="tabItem"
      @option-changed="onTabChanged"
    >
      <template #tabItem="{ data, index }">
        <div class="tab-label">
          <span>{{ data.text }}</span>
          <span v-if="index > 0" class="tab-close-btn" @click.stop="closeTab(index)">×</span>
        </div>
      </template>
    </DxTabs>

    <!-- Tab 0: Lista produse -->
    <div v-if="selectedTabIndex === 0" class="tab-content">
      <DxDataGrid
        ref="dataGrid"
        :data-source="dsProduse"
        key-expr="Id"
        height="100%"
        width="100%"
        :column-auto-width="false"
        :show-column-lines="false"
        :show-row-lines="true"
        :row-alternation-enabled="false"
        :hover-state-enabled="true"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        column-resizing-mode="nextColumn"
        @exporting="onExporting"
        :on-context-menu-preparing="onContextMenuPreparing"
        @row-dbl-click="onRowDblClick"
      >
        <DxStateStoring :enabled="true" type="localStorage" storage-key="grid-produse-state-v2" />
        <DxColumnChooser :enabled="true" title="Selector coloane" :allow-search="true" sort-order="asc" />
        <DxPaging :page-size="20" />
        <DxScrolling column-rendering-mode="virtual" />
        <DxLoadPanel :enabled="true" />
        <DxExport :enabled="true" :allow-export-selected-data="true" :formats="['xlsx', 'pdf']" />
        <DxFilterRow :visible="true" />

        <DxGridToolbar>
          <DxGridToolbarItem v-if="$route.query.ClasaID" template="backBtn" location="before" />
          <DxGridToolbarItem template="addProductBtn" />
          <DxGridToolbarItem name="columnChooserButton" />
          <DxGridToolbarItem name="exportButton" />
          <DxGridToolbarItem location="after" template="jurnalCodInternBtn" />
        </DxGridToolbar>
        <template #backBtn>
          <DxButton icon="back" text="Înapoi la Clase" styling-mode="outlined" @click="goBackToClase" />
        </template>
        <template #addProductBtn>
          <DxButton icon="plus" type="success" :width="30" :height="30"
            hint="Adaugă produs nou"
            @click="openAddProduct" />
        </template>
        <template #jurnalCodInternBtn>
          <DxButton text="Jurnal Cod Intern" icon="orderedlist" styling-mode="outlined" @click="openJurnalCodIntern" />
        </template>

        <!-- Thumbnail stânga -->
        <DxColumn :width="62" cell-template="thumbTemplate" :fixed="true" caption="" :allow-sorting="false" :allow-filtering="false" />
        <template #thumbTemplate="{ data }">
          <img v-if="data.data.Imagine"
            :src="`data:image/jpeg;base64,${data.data.Imagine}`"
            style="width:44px;height:44px;object-fit:cover;border-radius:50%;border:2px solid #e2e8f0;display:block;" />
          <div v-else style="width:44px;height:44px;border-radius:50%;background:#f1f5f9;border:2px solid #e2e8f0;display:flex;align-items:center;justify-content:center;">
            <i class="dx-icon dx-icon-photo" style="font-size:16px;color:#cbd5e1;" />
          </div>
        </template>

        <!-- Buton deschide dreapta -->
        <DxColumn :width="55" cell-template="openBtnTemplate" :fixed="true" fixed-position="right" caption="" :allow-sorting="false" :allow-filtering="false" />
        <template #openBtnTemplate="{ data }">
          <DxButton icon="eyeopen" styling-mode="outlined" hint="Deschide" @click="onOpenProduct(data.data)" />
        </template>

        <DxColumn data-field="Cod" :width="110" :fixed="true" caption="Cod Producător" />
        <DxColumn data-field="CodIntern" :width="120" :fixed="true" />
        <DxColumn data-field="Nume" :width="420" :fixed="true" />
        <DxColumn data-field="Categorie.Nume" caption="Categorie" :width="150" />
        <DxColumn data-field="CategorieId" :visible="false" :lookup="{ dataSource: dsCategorie, valueExpr: 'Id', displayExpr: 'Nume' }" />
        <DxColumn data-field="Unitate.Nume" caption="UM" :width="70" />
        <DxColumn data-field="UnitateId" :visible="false" :lookup="{ dataSource: dsUnitati, valueExpr: 'Id', displayExpr: 'Nume' }" />
        <DxColumn data-field="Activ" data-type="boolean" :width="70" caption="Activ" cell-template="activTemplate" />
        <template #activTemplate="{ data }">
          <span :class="data.data.Activ ? 'chip-activ' : 'chip-inactiv'">
            {{ data.data.Activ ? 'Activ' : 'Inactiv' }}
          </span>
        </template>
        <DxColumn data-field="NumeComercial" :visible="false" />
        <DxColumn data-field="Descriere" :visible="false" />
        <DxColumn data-field="CodBare" :visible="false" />
        <DxColumn data-field="Marker" :visible="false" />
        <DxColumn data-field="CategorieContabila.Nume" caption="Categorie Contabilă" :visible="false" />
        <DxColumn data-field="CategorieContabilaId" :visible="false" :lookup="{ dataSource: dsCategorieContabila, valueExpr: 'Id', displayExpr: 'Nume' }" />
        <DxColumn data-field="ClasificatieEconomica.Cod" :visible="false" caption="Clasificație Economică" />
        <DxColumn data-field="ClasificatieEconomicaId" :visible="false" :lookup="{ dataSource: dsClasificatieEconomica, valueExpr: 'ID', displayExpr: 'Cod' }" />
        <DxColumn data-field="TipEtichetaId" :visible="false" caption="Tip Etichetă" />
        <DxColumn data-field="CodD394" :visible="false" :lookup="{ dataSource: dsCoduriD394, valueExpr: 'Nume', displayExpr: 'Nume' }" />
        <DxColumn data-field="CategTva" :visible="false" />
        <DxColumn data-field="CategTvaMotivScutire" :visible="false" />
        <DxColumn data-field="CodCPV" :visible="false" />
        <DxColumn data-field="CodNc8id" :visible="false" />
        <DxColumn data-field="SursaProdus" :visible="false" caption="Sursă Produs" />
        <DxColumn data-field="Pret" caption="Preț" :visible="false" />
        <DxColumn data-field="PretVanzare" caption="Preț Vânzare" :visible="false" />
        <DxColumn data-field="PretValuta.Simbol" caption="Preț Valută" :visible="false" />
        <DxColumn data-field="PretValutaId" :visible="false" :lookup="{ dataSource: dsPretValuta, valueExpr: 'Id', displayExpr: 'Simbol' }" />
        <DxColumn data-field="PretCursBanca.Cod" caption="Preț Curs Bancă" :visible="false" />
        <DxColumn data-field="PretCursBancaId" :visible="false" :lookup="{ dataSource: dsBanci, valueExpr: 'ID', displayExpr: 'Cod' }" />
        <DxColumn data-field="PretVanzareData" :visible="false" />
        <DxColumn data-field="PretVanzareAnterior" :visible="false" />
        <DxColumn data-field="TaxareInversa" :visible="false" />
        <DxColumn data-field="TaxaVamala" caption="Taxă Vamală" :visible="false" />
        <DxColumn data-field="TvaCurent" :visible="false" />
        <DxColumn data-field="TvaCurentData" :visible="false" />
        <DxColumn data-field="TvaAnterior" :visible="false" />
        <DxColumn data-field="MasaBuc" caption="Masă Bucată" :visible="false" />
        <DxColumn data-field="MasaBucNet" :visible="false" />
        <DxColumn data-field="SeCantareste" caption="Se cântărește" :visible="false" />
        <DxColumn data-field="Stocabil" data-type="boolean" :visible="false" />
        <DxColumn data-field="QavertizareStoc" :visible="false" />
        <DxColumn data-field="Qaprovizionare" :visible="false" />
        <DxColumn data-field="LocDepozitare" :visible="false" />
        <DxColumn data-field="UnitateAmbalaj.Nume" caption="UM FA" :visible="false" />
        <DxColumn data-field="UnitateAmbalajId" :visible="false" :lookup="{ dataSource: dsUnitati, valueExpr: 'Id', displayExpr: 'Nume' }" />
        <DxColumn data-field="CantitatePt1Fa" :visible="false" />
        <DxColumn data-field="Serviciu" data-type="boolean" :set-cell-value="serviciuSetCellValue" :visible="false" />
        <DxColumn data-field="Producator" :visible="false" />
        <DxColumn data-field="ProducatorTara.Nume" :visible="false" />
        <DxColumn data-field="ProducatorTaraId" :visible="false" :lookup="{ dataSource: dsTari, valueExpr: 'ID', displayExpr: 'Nume' }" />
        <DxColumn data-field="GarantieLuni" :visible="false" />
        <DxColumn data-field="Url" :visible="false" />
        <DxColumn data-field="Imagine" :visible="false" :cell-template="cellTemplateImg" />
        <DxColumn data-field="WwwListat" :visible="false" />
        <DxColumn data-field="WwwVizibil" :visible="false" />
        <DxColumn data-field="WwwID" :visible="false" />
        <DxColumn data-field="WwwSyncedDate" :visible="false" />
        <DxColumn data-field="eMAGID" :visible="false" />
        <DxColumn data-field="eMAGIDBG" :visible="false" />
        <DxColumn data-field="eMAGIDHU" :visible="false" />
        <DxColumn data-field="CodPnk" :visible="false" />
        <DxColumn data-field="CodPNKBG" :visible="false" />
        <DxColumn data-field="CodPNKHU" :visible="false" />
        <DxColumn data-field="ProdusSgr.Nume" :visible="false" />
        <DxColumn data-field="ProdusSgrID" :visible="false" :lookup="{ dataSource: dsProduse, valueExpr: 'Id', displayExpr: 'Nume' }" />
        <DxColumn data-field="UserCreare" :visible="false" />
        <DxColumn data-field="DataCreare" :visible="false" />
        <DxColumn data-field="UserModificare" :visible="false" />
        <DxColumn data-field="DataModificare" :visible="false" />
      </DxDataGrid>
    </div>

    <!-- Selector Clasă + Categorie popup -->
    <DxPopupAdd
      :visible="selectorPopup.visible"
      :show-title="true"
      :width="740"
      :height="520"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      @hiding="onSelectorHide"
    >
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-hierarchy"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Selectare Categorie</div>
              <div class="popup-header-subtitle">Alege clasa și categoria pentru produsul nou</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--config">Pas 1 / 2</span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern sel-popup-body">
        <div class="sel-layout">

          <!-- Stânga: liste clase -->
          <div class="sel-left">
            <div class="sel-panel-header">
              <i class="dx-icon dx-icon-hierarchy sel-ph-icon"></i>
              <span class="sel-panel-title">Clase</span>
              <span v-if="selectorPopup.clasaList.length" class="sel-badge">{{ selectorPopup.clasaList.length }}</span>
            </div>
            <DxTextBox
              v-model:value="selectorPopup.clasaFilter"
              placeholder="Caută clasă..."
              :show-clear-button="true"
              styling-mode="outlined"
            />
            <div class="sel-list">
              <div v-if="!selectorPopup.clasaList.length" class="sel-empty">Se încarcă...</div>
              <div v-else-if="!filteredClase.length" class="sel-empty">Niciun rezultat</div>
              <div
                v-for="clasa in filteredClase"
                :key="clasa.ID"
                class="sel-item"
                :class="{ 'sel-item--active': selectorPopup.selectedClasaId === clasa.ID }"
                @click="onSelectorClasaClick(clasa.ID)"
              >
                <i class="dx-icon dx-icon-folder sel-item-icon" />
                <span class="sel-item-text">{{ clasa.NumeArborescent }}</span>
              </div>
            </div>
          </div>

          <!-- Dreapta: categorii pentru clasa selectată -->
          <div class="sel-right">
            <div class="sel-panel-header">
              <i class="dx-icon dx-icon-tags sel-ph-icon"></i>
              <span class="sel-panel-title">Categorii</span>
              <span v-if="selectorPopup.categoriiForClasa.length" class="sel-badge">{{ selectorPopup.categoriiForClasa.length }}</span>
            </div>
            <div class="sel-list">
              <div v-if="!selectorPopup.selectedClasaId" class="sel-empty sel-empty--hint">
                <i class="dx-icon dx-icon-back" style="font-size:22px;color:#cbd5e1;" />
                <span>Selectează o clasă din stânga</span>
              </div>
              <div v-else-if="selectorPopup.isLoadingCategorii" class="sel-empty">Se încarcă...</div>
              <div v-else-if="!selectorPopup.categoriiForClasa.length" class="sel-empty">
                Nicio categorie pentru această clasă
              </div>
              <div
                v-else
                v-for="cat in selectorPopup.categoriiForClasa"
                :key="cat.Id"
                class="sel-item sel-cat-item"
                :class="{ 'sel-item--active': selectorPopup.selectedCategorieId === cat.Id }"
                @click="() => { selectorPopup.selectedCategorieId = cat.Id; selectorPopup.selectedCategorie = cat; }"
                @dblclick="confirmSelectorCategorie"
              >
                <span class="sel-cat-cod">{{ cat.Cod }}</span>
                <span class="sel-cat-nume">{{ cat.Nume }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="sel-footer">
          <div class="sel-selection-info">
            <template v-if="selectorPopup.selectedCategorie">
              <i class="dx-icon dx-icon-check" style="color:#10b981;font-size:16px;" />
              <span>{{ selectorPopup.selectedCategorie.Cod }} — {{ selectorPopup.selectedCategorie.Nume }}</span>
            </template>
            <span v-else style="color:#94a3b8;font-size:13px;">Selectează o categorie pentru a continua</span>
          </div>
          <div style="display:flex;gap:8px;">
            <DxButton
              text="Continuă"
              type="success"
              styling-mode="contained"
              icon="arrowright"
              :disabled="!selectorPopup.selectedCategorieId"
              @click="confirmSelectorCategorie"
            />
            <DxButton text="Anulează" styling-mode="outlined" @click="onSelectorHide" />
          </div>
        </div>
      </div>
    </DxPopupAdd>

    <!-- Jurnal Cod Intern popup -->
    <DxPopupAdd
      :visible="jurnalPopup.visible"
      :show-title="true"
      title="Jurnal Cod Intern"
      :width="500"
      :height="650"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      @hiding="onJurnalHide"
    >
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-orderedlist"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Jurnal Cod Intern</div>
              <div class="popup-header-subtitle">Configurare generare coduri interne produse</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--config">Config</span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern">
        <div class="jurnal-popup-body">
        <div class="jp-field jp-switch-row">
          <DxSwitch v-model:value="jurnalPopup.editData.Activat" />
          <span class="jp-switch-label">Activ</span>
        </div>

        <div class="jp-field">
          <label class="jp-label">Număr de cifre:</label>
          <DxNumberBox v-model:value="jurnalPopup.editData.MaximCifre"
            :min="2" :max="9" :show-spin-buttons="true" :width="90" />
        </div>

        <div class="jp-field">
          <label class="jp-label">Nr. caractere din codul clasei:</label>
          <DxNumberBox v-model:value="jurnalPopup.editData.NrCaractereClasa"
            :min="0" :max="10" :show-spin-buttons="true" :width="90" />
        </div>

        <div class="jp-field">
          <label class="jp-label">Nr. caractere din codul grupei:</label>
          <DxNumberBox v-model:value="jurnalPopup.editData.NrCaractere"
            :min="0" :max="10" :show-spin-buttons="true" :width="90" />
        </div>

        <div class="jp-field">
          <label class="jp-label">Seria:</label>
          <DxTextBox v-model:value="jurnalPopup.editData.Seria" :width="200" />
        </div>

        <div class="jp-field">
          <label class="jp-label">Număr inițial:</label>
          <DxNumberBox v-model:value="jurnalPopup.editData.NumarInitial"
            :min="1" :show-spin-buttons="true" :width="200" />
        </div>

        <div class="jp-field jp-switch-row">
          <DxSwitch v-model:value="jurnalPopup.editData.IsCifraControl" />
          <span class="jp-switch-label">Cu cifră de control</span>
        </div>

        <div class="jp-field jp-switch-row">
          <DxSwitch v-model:value="jurnalPopup.editData.IsDelimitator"
            @value-changed="onDelimitatorChanged" />
          <span class="jp-switch-label">Cu delimitator</span>
          <DxTextBox v-model:value="jurnalPopup.editData.Delimitator"
            :disabled="!jurnalPopup.editData.IsDelimitator" :width="70" />
        </div>

        <div class="jp-curent-box">
          <div class="jp-curent-inner">
            <div class="jp-curent-text">Nr. curent (fără cifra de control):</div>
            <div class="jp-curent-value">{{ jurnalPopup.editData.NumarCurent }}</div>
            <DxButton text="Reset" type="danger" styling-mode="outlined"
              @click="resetJurnalNumar" />
          </div>
        </div>

        <div class="jp-exemplu">
          <span class="jp-exemplu-label">Exemplu:</span>
          <span class="jp-exemplu-value">{{ computeJurnalPreview() }}</span>
        </div>

        <div class="jp-footer">
          <DxButton text="Acceptă" type="success" styling-mode="contained" icon="check"
            @click="saveJurnalCodIntern" />
          <DxButton text="Renunță" styling-mode="outlined"
            @click="onJurnalHide" />
        </div>
      </div>
      </div>
    </DxPopupAdd>

    <!-- Adăugare Produs popup -->
    <DxPopupAdd
      :visible="isAddProductVisible"
      :show-title="true"
      :width="900"
      :height="680"
      :drag-enabled="true"
      :show-close-button="true"
      :close-on-outside-click="false"
      @hiding="isAddProductVisible = false"
    >
      <template #title>
        <div class="popup-header">
          <div class="popup-header-main">
            <span class="popup-header-icon dx-icon-add"></span>
            <div class="popup-header-texts">
              <div class="popup-header-title">Adăugare Produs</div>
              <div class="popup-header-subtitle">Completează datele produsului nou</div>
            </div>
          </div>
          <div class="popup-header-meta">
            <span class="status-chip status-chip--draft">Nou</span>
          </div>
        </div>
      </template>
      <div class="popup-body-modern">
        <div class="add-popup-grid">

          <!-- Card: Identificare (full width) -->
          <div class="produs-card produs-card-full">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#3b82f6,#1d4ed8)">
                <i class="dx-icon dx-icon-key" />
              </div>
              <div>
                <div class="pcard-title">Identificare</div>
                <div class="pcard-subtitle">Date principale și clasificare</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">Cod Producător <span class="field-req">*</span></label>
                  <DxTextBox v-model:value="newProductData.Cod" placeholder="#AUTO" />
                </div>
                <div class="pfield pfield-wide">
                  <label class="pfield-label">Denumire <span class="field-req">*</span></label>
                  <DxTextBox v-model:value="newProductData.Nume" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Categorie</label>
                  <DxSelectBox v-model:value="newProductData.CategorieId" :data-source="dsCategorie"
                    value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" placeholder="Selectează" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Unitate Măsură <span class="field-req">*</span></label>
                  <DxSelectBox v-model:value="newProductData.UnitateId" :data-source="dsUnitati"
                    value-expr="Id" display-expr="Nume" :search-enabled="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Categorie Contabilă <span class="field-req">*</span></label>
                  <DxSelectBox v-model:value="newProductData.CategorieContabilaId" :data-source="dsCategorieContabila"
                    value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                </div>
              </div>
              <div class="pfields-switches">
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.Activ" /><span>Activ</span>
                </div>
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.Serviciu" @value-changed="onServiciuAddChanged" /><span>Serviciu</span>
                </div>
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.Stocabil" /><span>Stocabil</span>
                </div>
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.SeCantareste" /><span>Se Cântărește</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Prețuri & TVA -->
          <div class="produs-card">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#10b981,#059669)">
                <i class="dx-icon dx-icon-money" />
              </div>
              <div>
                <div class="pcard-title">Prețuri & TVA</div>
                <div class="pcard-subtitle">Catalog, vânzare, taxe</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">Preț Catalog</label>
                  <DxNumberBox v-model:value="newProductData.Pret" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Preț Vânzare</label>
                  <DxNumberBox v-model:value="newProductData.PretVanzare" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Monedă</label>
                  <DxSelectBox v-model:value="newProductData.PretValutaId" :data-source="dsPretValuta"
                    value-expr="Id" display-expr="Simbol" :search-enabled="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Curs Bancă</label>
                  <DxSelectBox v-model:value="newProductData.PretCursBancaId" :data-source="dsBanci"
                    value-expr="ID" display-expr="Cod" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">TVA Curent (%)</label>
                  <DxNumberBox v-model:value="newProductData.TvaCurent" format="#,##0.##" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Data TVA</label>
                  <DxDateBox v-model:value="newProductData.TvaCurentData" display-format="dd.MM.yyyy" type="date" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Taxa Timbru Verde</label>
                  <DxNumberBox v-model:value="newProductData.TaxaVamala" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Garanție (luni)</label>
                  <DxNumberBox v-model:value="newProductData.GarantieLuni" :show-spin-buttons="true" :min="0" />
                </div>
              </div>
              <div class="pfields-switches">
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.TaxareInversa" /><span>Taxare Inversă</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Stoc & Depozit -->
          <div class="produs-card">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#f59e0b,#d97706)">
                <i class="dx-icon dx-icon-product" />
              </div>
              <div>
                <div class="pcard-title">Stoc & Depozit</div>
                <div class="pcard-subtitle">Parametri gestiune și ambalare</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">UM Ambalaj</label>
                  <DxSelectBox v-model:value="newProductData.UnitateAmbalajId" :data-source="dsUnitati"
                    value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cantitate pt. 1 FA</label>
                  <DxNumberBox v-model:value="newProductData.CantitatePt1Fa" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Masă Bucată (g)</label>
                  <DxNumberBox v-model:value="newProductData.MasaBuc" format="#,##0.00######" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Masă Net (g)</label>
                  <DxNumberBox v-model:value="newProductData.MasaBucNet" format="#,##0.00######" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Q Avertizare Stoc</label>
                  <DxNumberBox v-model:value="newProductData.QavertizareStoc" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Q Aprovizionare</label>
                  <DxNumberBox v-model:value="newProductData.Qaprovizionare" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Loc Depozitare</label>
                  <DxTextBox v-model:value="newProductData.LocDepozitare" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Tip Etichetă</label>
                  <DxTextBox v-model:value="newProductData.TipEtichetaId" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Sursă Produs</label>
                  <DxSelectBox v-model:value="newProductData.SursaProdus" :data-source="dsSursaProdus"
                    value-expr="id" display-expr="text" :show-clear-button="true" placeholder="Selectați sursa" />
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Clasificare -->
          <div class="produs-card">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#8b5cf6,#6d28d9)">
                <i class="dx-icon dx-icon-orderedlist" />
              </div>
              <div>
                <div class="pcard-title">Clasificare</div>
                <div class="pcard-subtitle">Coduri contabile și clasificații</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">Clasificație Economică</label>
                  <DxSelectBox v-model:value="newProductData.ClasificatieEconomicaId" :data-source="dsClasificatieEconomica"
                    value-expr="ID" display-expr="Cod" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod D394</label>
                  <DxSelectBox v-model:value="newProductData.CodD394" :data-source="dsCoduriD394"
                    value-expr="Nume" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Categorie TVA</label>
                  <DxTextBox v-model:value="newProductData.CategTva" />
                </div>
                <div class="pfield pfield-wide">
                  <label class="pfield-label">Motiv Scutire TVA</label>
                  <DxTextBox v-model:value="newProductData.CategTvaMotivScutire" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod CPV</label>
                  <DxTextBox v-model:value="newProductData.CodCPV" />
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Prezentare -->
          <div class="produs-card">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#ec4899,#db2777)">
                <i class="dx-icon dx-icon-photo" />
              </div>
              <div>
                <div class="pcard-title">Prezentare</div>
                <div class="pcard-subtitle">Producător, coduri, imagine</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">Producător</label>
                  <DxTextBox v-model:value="newProductData.Producator" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Țara Producătorului</label>
                  <DxSelectBox v-model:value="newProductData.ProducatorTaraId" :data-source="dsTari"
                    value-expr="ID" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod NC8</label>
                  <DxTextBox v-model:value="newProductData.CodNc8id" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod Bare (Producător)</label>
                  <DxTextBox v-model:value="newProductData.CodBare" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Marker</label>
                  <DxTextBox v-model:value="newProductData.Marker" />
                </div>
                <div class="pfield pfield-wide">
                  <label class="pfield-label">URL</label>
                  <DxTextBox v-model:value="newProductData.Url" />
                </div>
              </div>
              <div class="add-imagine-section" style="margin-top:12px;padding-top:12px;border-top:1px solid #f1f5f9;">
                <label class="pfield-label" style="display:block;margin-bottom:8px;">Imagine produs</label>
                <div class="add-imagine-row">
                  <div v-if="newProductData.Imagine" class="add-imagine-preview">
                    <img :src="`data:image/jpeg;base64,${newProductData.Imagine}`" alt="Imagine produs" />
                  </div>
                  <div v-else class="imagine-placeholder" style="width:80px;height:60px;font-size:11px;">
                    <i class="dx-icon dx-icon-photo" /><span>Fără imagine</span>
                  </div>
                  <div style="display:flex;flex-direction:column;gap:6px;">
                    <label class="imagine-upload-btn">
                      <i class="dx-icon dx-icon-upload" /> Încarcă
                      <input type="file" accept="image/*" @change="onAddImageChange" />
                    </label>
                    <DxButton v-if="newProductData.Imagine" text="Șterge" type="danger"
                      styling-mode="outlined" :height="30" @click="() => { newProductData.Imagine = null; }" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Card: Marketplace & Web (full width) -->
          <div class="produs-card produs-card-full">
            <div class="pcard-header">
              <div class="pcard-icon" style="background:linear-gradient(135deg,#14b8a6,#0d9488)">
                <i class="dx-icon dx-icon-globe" />
              </div>
              <div>
                <div class="pcard-title">Marketplace & Web</div>
                <div class="pcard-subtitle">Coduri marketplace, SGR și publicare</div>
              </div>
            </div>
            <div class="pcard-body">
              <div class="pfields-row">
                <div class="pfield">
                  <label class="pfield-label">Cod PNK</label>
                  <DxTextBox v-model:value="newProductData.CodPnk" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod PNK BG</label>
                  <DxTextBox v-model:value="newProductData.CodPNKBG" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Cod PNK HU</label>
                  <DxTextBox v-model:value="newProductData.CodPNKHU" />
                </div>
                <div class="pfield">
                  <label class="pfield-label">Produs SGR</label>
                  <DxSelectBox v-model:value="newProductData.ProdusSgrID" :data-source="dsProduse"
                    value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                </div>
                <div class="pfield pfield-wide">
                  <label class="pfield-label">Nume Comercial</label>
                  <DxTextBox v-model:value="newProductData.NumeComercial" />
                </div>
                <div class="pfield pfield-wide">
                  <label class="pfield-label">Descriere</label>
                  <DxTextArea v-model:value="newProductData.Descriere" :height="60" />
                </div>
              </div>
              <div class="pfields-switches">
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.WwwListat" /><span>WWW Listat</span>
                </div>
                <div class="pfield-switch">
                  <DxSwitch v-model:value="newProductData.WwwVizibil" /><span>WWW Vizibil</span>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="add-product-footer">
          <DxButton text="Salvează" type="success" styling-mode="contained" icon="check" @click="saveNewProduct" />
          <DxButton text="Renunță" styling-mode="outlined" @click="isAddProductVisible = false" />
        </div>
      </div>
    </DxPopupAdd>

    <!-- Product detail tabs -->
    <template v-for="(item, i) in openProducts" :key="item.id">
      <div v-if="selectedTabIndex === i + 1" class="tab-content produs-tab-content">
        <!-- Gradient header -->
        <div class="produs-header">
          <div class="produs-header-left">
            <div class="produs-header-icon">
              <i class="dx-icon dx-icon-box" />
            </div>
            <div>
              <div class="produs-header-name">{{ item.editData.Nume || 'Produs' }}</div>
              <div class="produs-header-chips">
                <span v-if="item.editData.Cod" class="pchip pchip-code">{{ item.editData.Cod }}</span>
                <span v-if="item.editData.CodIntern" class="pchip pchip-intern">{{ item.editData.CodIntern }}</span>
                <span :class="['pchip', item.editData.Activ ? 'pchip-activ' : 'pchip-inactiv']">
                  {{ item.editData.Activ ? 'Activ' : 'Inactiv' }}
                </span>
                <span v-if="item.editData.Serviciu" class="pchip pchip-serviciu">Serviciu</span>
                <span v-else-if="item.editData.Stocabil" class="pchip pchip-stocabil">Stocabil</span>
              </div>
            </div>
          </div>
          <div class="produs-header-actions">
            <template v-if="item.isEditing">
              <DxButton text="Salvează" styling-mode="outlined" icon="save" class="header-btn-save" @click="saveProduct(i)" />
              <DxButton text="Anulează" styling-mode="outlined" icon="close" class="header-btn-cancel" @click="cancelEdit(i)" />
            </template>
          </div>
        </div>

        <!-- Cards scroll -->
        <div class="produs-cards-scroll">
          <div class="produs-cards-grid">

            <!-- Card: Identificare (full width) -->
            <div class="produs-card produs-card-full">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#3b82f6,#1d4ed8)">
                  <i class="dx-icon dx-icon-key" />
                </div>
                <div>
                  <div class="pcard-title">Identificare</div>
                  <div class="pcard-subtitle">Coduri și denumire principală</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-row">
                  <div class="pfield">
                    <label class="pfield-label">Cod Producător</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Cod" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod Intern</label>
                    <DxTextBox :value="item.editData.CodIntern" :read-only="true" placeholder="#AUTO" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Denumire *</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Nume" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Categorie</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.CategorieId" :data-source="dsCategorie"
                      value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Unitate Măsură</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.UnitateId" :data-source="dsUnitati"
                      value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Tip Etichetă</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.TipEtichetaId" />
                  </div>
                </div>
                <div class="pfields-switches">
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.Activ" />
                    <span>Activ</span>
                  </div>
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.Serviciu"
                      @value-changed="(e) => onServiciuChanged(e, item)" />
                    <span>Serviciu</span>
                  </div>
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.Stocabil" />
                    <span>Stocabil</span>
                  </div>
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.SeCantareste" />
                    <span>Se Cântărește</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card: Prețuri & TVA -->
            <div class="produs-card produs-card-span2">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#10b981,#059669)">
                  <i class="dx-icon dx-icon-money" />
                </div>
                <div>
                  <div class="pcard-title">Prețuri & TVA</div>
                  <div class="pcard-subtitle">Prețuri de catalog și taxe</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-row">
                  <div class="pfield">
                    <label class="pfield-label">Preț Catalog</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.Pret" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Preț Vânzare</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.PretVanzare" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Preț Vânzare Anterior</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.PretVanzareAnterior" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Preț Vânzare Dată</label>
                    <DxDateBox :read-only="!item.isEditing" v-model:value="item.editData.PretVanzareData" display-format="dd.MM.yyyy" type="date" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Monedă</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.PretValutaId" :data-source="dsPretValuta"
                      value-expr="Id" display-expr="Simbol" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Curs Bancă</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.PretCursBancaId" :data-source="dsBanci"
                      value-expr="ID" display-expr="Cod" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">TVA Curent (%)</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.TvaCurent" format="#,##0.##" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Data TVA</label>
                    <DxDateBox :read-only="!item.isEditing" v-model:value="item.editData.TvaCurentData" display-format="dd/MM/yyyy" type="date" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">TVA Anterior (%)</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.TvaAnterior" format="#,##0.##" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Taxă Timbru Verde</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.TaxaVamala" format="#,##0.00####" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Garantie (luni)</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.GarantieLuni" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Categorie TVA</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CategTva" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Motiv Scutire TVA</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CategTvaMotivScutire" />
                  </div>
                </div>
                <div class="pfields-switches">
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.TaxareInversa" />
                    <span>Taxare Inversă</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card: Clasificare Contabilă -->
            <div class="produs-card">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#8b5cf6,#6d28d9)">
                  <i class="dx-icon dx-icon-orderedlist" />
                </div>
                <div>
                  <div class="pcard-title">Clasificare Contabilă</div>
                  <div class="pcard-subtitle">Categorii și coduri contabile</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-col">
                  <div class="pfield">
                    <label class="pfield-label">Clasificație Economică</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.ClasificatieEconomicaId" :data-source="dsClasificatieEconomica"
                      value-expr="ID" display-expr="Cod" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod D394</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.CodD394" :data-source="dsCoduriD394"
                      value-expr="Nume" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod CPV</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodCPV" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Card: Prezentare & Media -->
            <div class="produs-card produs-card-full">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#ec4899,#db2777)">
                  <i class="dx-icon dx-icon-photo" />
                </div>
                <div>
                  <div class="pcard-title">Prezentare & Media</div>
                  <div class="pcard-subtitle">Producător, coduri, imagine</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-row">
                  <div class="pfield">
                    <label class="pfield-label">Producător</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Producator" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Țara Producătorului</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.ProducatorTaraId" :data-source="dsTari"
                      value-expr="ID" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod NC8</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodNc8id" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod Bare</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodBare" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Marker</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Marker" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">URL</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Url" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Denumire Comercială</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.NumeComercial" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Categorie Contabilă</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.CategorieContabilaId" :data-source="dsCategorieContabila"
                      value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield pfield-full">
                    <label class="pfield-label">Descriere</label>
                    <DxTextArea :read-only="!item.isEditing" v-model:value="item.editData.Descriere" :height="70" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Compatibilitate</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.Compatibilitate" />
                  </div>
                </div>
                <!-- Image section -->
                <div class="imagine-section">
                  <label class="pfield-label">Imagine produs</label>
                  <div class="imagine-container">
                    <div v-if="item.editData.Imagine" class="imagine-preview">
                      <img :src="`data:image/jpeg;base64,${item.editData.Imagine}`" alt="Imagine produs" />
                    </div>
                    <div v-else class="imagine-placeholder">
                      <i class="dx-icon dx-icon-photo" />
                      <span>Nicio imagine</span>
                    </div>
                    <div v-if="item.isEditing" class="imagine-actions">
                      <label class="imagine-upload-btn">
                        <i class="dx-icon dx-icon-upload" /> Încarcă imagine
                        <input type="file" accept="image/*" @change="onImageChange($event, item)" />
                      </label>
                      <DxButton v-if="item.editData.Imagine" text="Șterge" type="danger" styling-mode="outlined"
                        @click="() => { item.editData.Imagine = null; item.imagineChanged = true; }" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Card: Stoc & Depozit -->
            <div class="produs-card">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#f59e0b,#d97706)">
                  <i class="dx-icon dx-icon-product" />
                </div>
                <div>
                  <div class="pcard-title">Stoc & Depozit</div>
                  <div class="pcard-subtitle">Gestiune și parametri stoc</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-row">
                  <div class="pfield">
                    <label class="pfield-label">UM Ambalaj</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.UnitateAmbalajId" :data-source="dsUnitati"
                      value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cantitate pt. 1 FA</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.CantitatePt1Fa" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Q Avertizare Stoc</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.QavertizareStoc" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Q Aprovizionare</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.Qaprovizionare" format="#,##0.###" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Loc Depozitare</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.LocDepozitare" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Masă Bucată</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.MasaBuc" format="#,##0.00######" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Masă Net</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.MasaBucNet" format="#,##0.00######" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Sursă Produs</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.SursaProdus" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Card: Marketplace & Web -->
            <div class="produs-card produs-card-span2">
              <div class="pcard-header">
                <div class="pcard-icon" style="background:linear-gradient(135deg,#14b8a6,#0d9488)">
                  <i class="dx-icon dx-icon-globe" />
                </div>
                <div>
                  <div class="pcard-title">Marketplace & Web</div>
                  <div class="pcard-subtitle">Coduri marketplace și publicare web</div>
                </div>
              </div>
              <div class="pcard-body">
                <div class="pfields-row">
                  <div class="pfield">
                    <label class="pfield-label">Cod PNK</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodPnk" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod PNK BG</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodPNKBG" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Cod PNK HU</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.CodPNKHU" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">eMAG ID</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.eMAGID" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">eMAG ID BG</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.eMAGIDBG" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">eMAG ID HU</label>
                    <DxTextBox :read-only="!item.isEditing" v-model:value="item.editData.eMAGIDHU" />
                  </div>
                  <div class="pfield pfield-wide">
                    <label class="pfield-label">Produs SGR</label>
                    <DxSelectBox :read-only="!item.isEditing" v-model:value="item.editData.ProdusSgrID" :data-source="dsProduse"
                      value-expr="Id" display-expr="Nume" :search-enabled="true" :show-clear-button="true" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Www ID</label>
                    <DxNumberBox :read-only="!item.isEditing" v-model:value="item.editData.WwwID" :show-spin-buttons="true" :min="0" />
                  </div>
                  <div class="pfield">
                    <label class="pfield-label">Www Synced Date</label>
                    <DxDateBox :read-only="!item.isEditing" v-model:value="item.editData.WwwSyncedDate" display-format="dd.MM.yyyy HH:mm" type="datetime" />
                  </div>
                </div>
                <div class="pfields-switches">
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.WwwListat" />
                    <span>Www Listat</span>
                  </div>
                  <div class="pfield-switch">
                    <DxSwitch :read-only="!item.isEditing" v-model:value="item.editData.WwwVizibil" />
                    <span>Www Vizibil</span>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <DxSpeedDialAction
          v-if="!item.isEditing"
          icon="edit"
          label="Editează"
          :index="1"
          @click="item.isEditing = true"
        />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import { DxSpeedDialAction } from 'devextreme-vue/speed-dial-action';
import { DxTabs } from 'devextreme-vue/tabs';
import { DxTextBox } from 'devextreme-vue/text-box';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxDateBox } from 'devextreme-vue/date-box';
import { DxSwitch } from 'devextreme-vue/switch';
import { DxTextArea } from 'devextreme-vue/text-area';
import DxPopupAdd from 'devextreme-vue/popup';
import DataSource from 'devextreme/data/data_source';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
import ProduseService from '@/services/PRO/Produse';
import notify from 'devextreme/ui/notify';
import { jsPDF } from 'jspdf';
import { exportDataGrid as exportDataGridPdf } from 'devextreme/pdf_exporter';
import { exportDataGrid as exportDataGridExcel } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import {
    DxItem as DxGridToolbarItem,
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxScrolling,
    DxStateStoring,
    DxToolbar as DxGridToolbar,
    DxColumnChooser,
    DxExport,
    DxSearchPanel,
} from 'devextreme-vue/data-grid';

export default defineComponent({
    components: {
        DxTabs,
        DxTextBox,
        DxNumberBox,
        DxSelectBox,
        DxDateBox,
        DxSwitch,
        DxTextArea,
        DxGridToolbar,
        DxDataGrid,
        DxColumn,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxSpeedDialAction,
        DxPopupAdd,
        DxScrolling,
        DxColumnChooser,
        DxExport,
        DxSearchPanel,
        DxGridToolbarItem,
    },
    data() {
        return {
            tabs: [{ text: 'Produse' }] as { text: string }[],
            openProducts: [] as any[],
            selectedTabIndex: 0,
            jurnalPopup: {
                visible: false,
                editData: {
                    Activat: false, MaximCifre: 4, NrCaractereClasa: 0, NrCaractere: 0,
                    Seria: '', NumarInitial: 1, IsCifraControl: false,
                    IsDelimitator: false, Delimitator: '', NumarCurent: 1,
                } as any,
            },
            selectorPopup: {
                visible: false,
                clasaList: [] as any[],
                clasaFilter: '',
                selectedClasaId: null as string | null,
                selectedCategorieId: null as string | null,
                selectedCategorie: null as any,
                categoriiForClasa: [] as any[],
                isLoadingCategorii: false,
            },
            isAddProductVisible: false,
            newProductData: {
                Cod: '', Nume: '', CategorieId: null,
                UnitateId: '31FD11E4-19B7-46E0-BBD5-204595349595',
                Activ: true, Serviciu: false, Stocabil: true, SeCantareste: false,
                Pret: 0, PretVanzare: 0,
                PretValutaId: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                TvaCurent: 19, TvaCurentData: new Date(),
                GarantieLuni: 12,
                CategorieContabilaId: '119E7784-3247-409C-AA8B-BB5D5D4A6AE5',
                Imagine: null as string | null,
            } as any,
            dsSursaProdus: [
                { id: 0, text: 'Achiziție externă' },
                { id: 1, text: 'Reper/Subansamblu' },
            ],
            dsClase: {} as DataSource,
            dsProduse: {} as DataSource,
            dsUnitati: {} as DataSource,
            dsCategorie: {} as DataSource,
            dsCategorieContabila: {} as DataSource,
            dsPretValuta: {} as DataSource,
            dsTari: {} as DataSource,
            dsBanci: {} as DataSource,
            dsCoduriD394: {} as DataSource,
            dsClasificatieEconomica: {} as DataSource,
            dataGrid: ref<DxDataGrid | null>(null),
        };
    },
    computed: {
        filteredClase(): any[] {
            const f = (this.selectorPopup.clasaFilter || '').toLowerCase().trim();
            if (!f) return this.selectorPopup.clasaList;
            return this.selectorPopup.clasaList.filter((c: any) =>
                (c.NumeArborescent || '').toLowerCase().includes(f)
            );
        },
    },
    watch: {
        '$route.query.CategorieId': {
            handler() { this.createODataContext(); },
            immediate: false,
        },
    },
    created() {
        this.createODataContext();
    },
    mounted() {
        this.dataGrid = this.$refs.dataGrid as DxDataGrid;
    },
    methods: {
        onTabChanged(e: any) {
            if (e.name === 'selectedIndex') {
                this.selectedTabIndex = e.value;
            }
        },

        onRowDblClick(e: any) {
            if (e.rowType === 'data') this.onOpenProduct(e.data);
        },
        onOpenProduct(productData: any) {
            const productId = String(productData?.Id ?? productData?.id ?? '');
            if (!productId) return;
            const existingIndex = this.openProducts.findIndex(p => String(p.id) === productId);
            if (existingIndex !== -1) {
                this.selectedTabIndex = existingIndex + 1;
                return;
            }
            const editData = { ...productData };
            const originalData = { ...productData };
            this.openProducts.push({ id: productId, editData, originalData, imagineChanged: false, isEditing: false });
            const label = productData.Cod
                ? productData.Cod
                : (productData.Nume || 'Produs').substring(0, 18);
            this.tabs = [...this.tabs, { text: label }];
            this.selectedTabIndex = this.tabs.length - 1;
        },

        closeTab(index: number) {
            this.openProducts.splice(index - 1, 1);
            this.tabs = this.tabs.filter((_, i) => i !== index);
            if (this.selectedTabIndex >= this.tabs.length) {
                this.selectedTabIndex = this.tabs.length - 1;
            }
        },

        async saveProduct(tabIndex: number) {
            const item = this.openProducts[tabIndex];
            if (!item.editData.Nume?.trim()) {
                notify('Câmpul Denumire este obligatoriu!', 'error', 3000);
                return;
            }
            const payload = this.buildSavePayload(item.editData, item.imagineChanged);
            try {
                await ProduseService.update(item.id, payload);
                item.originalData = { ...item.editData };
                item.imagineChanged = false;
                item.isEditing = false;
                const label = item.editData.Cod
                    ? item.editData.Cod
                    : (item.editData.Nume || 'Produs').substring(0, 18);
                this.tabs[tabIndex + 1] = { text: label };
                notify('Modificările au fost salvate.', 'success', 2000);
                this.dsProduse.reload().catch(() => {});
            } catch (err: any) {
                const msg = err?.message || err?.errorDetails || 'Eroare la salvare!';
                notify(msg, 'error', 4000);
            }
        },

        cancelEdit(tabIndex: number) {
            const item = this.openProducts[tabIndex];
            item.editData = { ...item.originalData };
            item.imagineChanged = false;
            item.isEditing = false;
        },

        buildSavePayload(editData: any, imagineChanged: boolean) {
            const payload: any = {
                Cod: editData.Cod,
                Nume: editData.Nume,
                UnitateId: editData.UnitateId,
                CategorieId: editData.CategorieId,
                Pret: editData.Pret,
                CategorieContabilaId: editData.CategorieContabilaId,
                TaxaVamala: editData.TaxaVamala,
                Url: editData.Url,
                PretVanzare: editData.PretVanzare,
                MasaBuc: editData.MasaBuc,
                SeCantareste: editData.SeCantareste,
                PretValutaId: editData.PretValutaId,
                PretCursBancaId: editData.PretCursBancaId,
                SursaProdus: editData.SursaProdus,
                TipEtichetaId: editData.TipEtichetaId,
                LocDepozitare: editData.LocDepozitare,
                ClasificatieEconomicaId: editData.ClasificatieEconomicaId,
                QavertizareStoc: editData.QavertizareStoc,
                Qaprovizionare: editData.Qaprovizionare,
                UnitateAmbalajId: editData.UnitateAmbalajId,
                CantitatePt1Fa: editData.CantitatePt1Fa,
                TvaCurent: editData.TvaCurent,
                TvaCurentData: editData.TvaCurentData,
                TvaAnterior: editData.TvaAnterior,
                Stocabil: editData.Stocabil,
                Serviciu: editData.Serviciu,
                TaxareInversa: editData.TaxareInversa,
                Marker: editData.Marker,
                CodD394: editData.CodD394,
                GarantieLuni: editData.GarantieLuni,
                Producator: editData.Producator,
                CodBare: editData.CodBare,
                NumeComercial: editData.NumeComercial,
                ProducatorTaraId: editData.ProducatorTaraId,
                CodNc8id: editData.CodNc8id,
                Descriere: editData.Descriere,
                Compatibilitate: editData.Compatibilitate,
                PretVanzareData: editData.PretVanzareData,
                PretVanzareAnterior: editData.PretVanzareAnterior,
                CategTva: editData.CategTva,
                CategTvaMotivScutire: editData.CategTvaMotivScutire,
                MasaBucNet: editData.MasaBucNet,
                CodPnk: editData.CodPnk,
                eMAGID: editData.eMAGID,
                CodPNKBG: editData.CodPNKBG,
                CodPNKHU: editData.CodPNKHU,
                eMAGIDBG: editData.eMAGIDBG,
                eMAGIDHU: editData.eMAGIDHU,
                ProdusSgrID: editData.ProdusSgrID,
                CodCPV: editData.CodCPV,
                Activ: editData.Activ,
                WwwListat: editData.WwwListat,
                WwwVizibil: editData.WwwVizibil,
                WwwID: editData.WwwID,
                WwwSyncedDate: editData.WwwSyncedDate,
            };
            if (imagineChanged) {
                payload.Imagine = editData.Imagine;
            }
            return payload;
        },

        onServiciuChanged(e: any, item: any) {
            item.editData.Stocabil = !e.value;
        },

        onImageChange(event: Event, item: any) {
            const input = event.target as HTMLInputElement;
            const file = input.files?.[0];
            if (!file) return;
            if (!file.type.startsWith('image/')) {
                notify('Selectează o imagine.', 'error', 2000);
                return;
            }
            if (file.size > 5 * 1024 * 1024) {
                notify('Fișier prea mare (max 5 MB).', 'error', 2000);
                return;
            }
            const reader = new FileReader();
            reader.onload = (ev) => {
                const dataUrl = String(ev.target?.result || '');
                const comma = dataUrl.indexOf(',');
                item.editData.Imagine = comma >= 0 ? dataUrl.substring(comma + 1) : dataUrl;
                item.imagineChanged = true;
            };
            reader.readAsDataURL(file);
        },

        async openJurnalCodIntern() {
            try {
                const res = await fetch(AppSetting.API_Url_ComercialOdata + 'PRO_CodIntern?$top=1', {
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        'Content-Type': 'application/json',
                    },
                });
                const json = await res.json();
                const rows = json.value || [];
                if (rows.length > 0) {
                    Object.assign(this.jurnalPopup.editData, rows[0]);
                    this.jurnalPopup.visible = true;
                } else {
                    notify('Nu există configurare Jurnal Cod Intern în baza de date.', 'warning', 3000);
                }
            } catch {
                notify('Eroare la încărcarea Jurnal Cod Intern.', 'error', 3000);
            }
        },

        async saveJurnalCodIntern() {
            const d = this.jurnalPopup.editData;
            if (!d) return;
            const payload = {
                NrCaractere: d.NrCaractere,
                NrCaractereClasa: d.NrCaractereClasa,
                Seria: d.Seria,
                NumarInitial: d.NumarInitial,
                NumarCurent: d.NumarCurent,
                MaximCifre: d.MaximCifre,
                IsCifraControl: d.IsCifraControl,
                IsDelimitator: d.IsDelimitator,
                Delimitator: d.Delimitator,
                Activat: d.Activat,
            };
            try {
                const res = await fetch(
                    AppSetting.API_Url_ComercialOdata + 'PRO_CodIntern(' + d.ID + ')',
                    {
                        method: 'PATCH',
                        headers: {
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                    }
                );
                if (!res.ok) throw new Error(await res.text());
                notify('Jurnal Cod Intern salvat cu succes.', 'success', 2000);
                this.jurnalPopup.visible = false;
            } catch (err: any) {
                notify(err?.message || 'Eroare la salvare!', 'error', 3000);
            }
        },

        resetJurnalNumar() {
            if (!this.jurnalPopup.editData) return;
            this.jurnalPopup.editData.NumarCurent = this.jurnalPopup.editData.NumarInitial;
        },

        onDelimitatorChanged(e: any) {
            if (e.value && !this.jurnalPopup.editData?.Delimitator) {
                this.jurnalPopup.editData.Delimitator = '-';
            }
        },

        computeJurnalPreview(): string {
            const d = this.jurnalPopup.editData;
            if (!d) return '';
            let codCls = 'BBBBBBBB';
            const nrCls = Math.max(0, Number(d.NrCaractereClasa) || 0);
            while (codCls.length < nrCls) codCls = ' ' + codCls;
            codCls = codCls.substring(0, nrCls);

            let codCat = 'AAAAAAAA';
            const nrCar = Math.max(0, Number(d.NrCaractere) || 0);
            while (codCat.length < nrCar) codCat = ' ' + codCat;
            codCat = codCat.substring(0, nrCar);

            const iCifra = d.IsCifraControl ? 1 : 0;
            const maxCifre = Math.max(2, Number(d.MaximCifre) || 6);
            const nrInitial = Number(d.NumarInitial) || 1;
            const numar = String(nrInitial).padStart(maxCifre - iCifra, '0');
            const del = d.IsDelimitator ? (d.Delimitator || '') : '';
            const s0 = codCls + codCat + del + (d.Seria || '') + del + numar;

            const ck0 = this._checksumEan13(s0);
            if (ck0 >= 0) return s0 + String(ck0);
            if (d.IsCifraControl) return s0 + this._ccc(numar);
            return s0;
        },

        _checksumEan13(data: string): number {
            if (data.length !== 12 && data.length !== 13) return -1;
            for (let i = 0; i < data.length; i++) {
                const c = data.charCodeAt(i);
                if (c < 0x30 || c > 0x39) return -1;
            }
            let iSum = 0;
            for (let i = data.length; i >= 1; i--) {
                const iDigit = parseInt(data[i - 1], 10);
                iSum += (i % 2 === 0) ? iDigit * 3 : iDigit;
            }
            return (10 - (iSum % 10)) % 10;
        },

        _ccc(cf: string): string {
            const ponderi = [1, 2, 3, 5, 7, 1, 2, 3, 5, 7];
            let rest = 0;
            const s = cf.trim();
            for (let i = s.length, j = 0; i > 0; i--, j++) {
                const b = s.charCodeAt(s.length - i) - 0x30;
                if (b < 0 || b > 9) return '-2';
                rest += b * ponderi[j];
            }
            rest = (rest * 10) % 11;
            return rest > 9 ? '0' : String(rest);
        },

        createODataContext() {
            const catId = this.$route.query.CategorieId || null;

            this.dsProduse = new DataSource({
                store: new ODataStore({
                    url: AppSetting.API_Url_ComercialOdata + 'PRO_Produse',
                    key: 'Id',
                    version: 4,
                    errorHandler: (e) => {
                        const msg = (e as any)?.errorDetails || 'Codul sau denumirea produsului există deja!';
                        notify({ message: msg, type: 'error', displayTime: 4000 });
                    },
                    fieldTypes: {
                        Id: 'Guid',
                        CategorieId: 'Guid',
                        UnitateId: 'Guid',
                        UnitateAmbalajId: 'Guid',
                        CategorieContabilaId: 'Guid',
                        ClasificatieEconomicaId: 'Guid',
                        PretValutaId: 'Guid',
                        PretCursBancaId: 'Guid',
                        ProdusSgrID: 'Guid',
                        ProducatorTaraId: 'Guid',
                    },
                    beforeSend: (e: any) => {
                        e.headers = {
                            'Content-Type': 'application/json',
                            Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                        };
                        e.params.$expand =
                            'Unitate($select=Nume),' +
                            'Categorie($select=Nume),' +
                            'CategorieContabila($select=Nume),' +
                            'PretValuta($select=Simbol),' +
                            'UnitateAmbalaj($select=Nume),' +
                            'ClasificatieEconomica($select=Cod),' +
                            'CoduriD394($select=Nume),' +
                            'ProducatorTara($select=Nume),' +
                            'ProdusSgr($select=Nume)';
                    },
                }),
                ...(catId ? { filter: ['CategorieId', '=', catId] } : {}),
            });

            const makeSimpleStore = (url: string, key: string, keyType = 'Guid', select?: string[]) =>
                new DataSource({
                    store: {
                        type: 'odata',
                        url: AppSetting.API_Url_ComercialOdata + url,
                        key,
                        keyType,
                        version: 4,
                        beforeSend: (e: any) => {
                            e.headers = {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                            };
                        },
                    } as any,
                    ...(select ? { select } : {}),
                    sort: [{ selector: select?.[1] || 'Nume', desc: false }],
                });

            this.dsCategorie = makeSimpleStore('PRO_Categorii', 'Id', 'Guid', ['Id', 'Nume', 'ClasaId']);
            this.dsClase = makeSimpleStore('PRO_Clase', 'ID', 'Guid', ['ID', 'NumeArborescent']);
            this.dsCoduriD394 = new DataSource({
                store: { type: 'odata', key: undefined, url: AppSetting.API_Url_ComercialOdata + 'PRO_CoduriD394', version: 4, beforeSend: (e: any) => { e.headers = { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') }; } } as any,
                select: ['Nume'],
                sort: [{ selector: 'Nume', desc: false }],
            });
            this.dsClasificatieEconomica = makeSimpleStore('BUG_ClasificatieEconomica', 'ID', 'Guid', ['ID', 'Cod']);
            (this.dsClasificatieEconomica as any).sort = [{ selector: 'Cod', desc: false }];
            this.dsBanci = makeSimpleStore('ERP_Banci', 'ID', 'Guid', ['ID', 'Cod']);
            this.dsUnitati = makeSimpleStore('PRO_Unitati', 'Id', 'Guid', ['Id', 'Nume']);
            this.dsCategorieContabila = makeSimpleStore('CON_CategoriiContabile', 'Id', 'Guid', ['Id', 'Nume']);
            this.dsPretValuta = makeSimpleStore('ERP_Valute', 'Id', 'Guid', ['Id', 'Simbol']);
            (this.dsPretValuta as any).sort = [{ selector: 'Simbol', desc: false }];
            this.dsTari = makeSimpleStore('ERP_Tari', 'ID', 'Guid', ['ID', 'Nume']);
        },

        cellTemplateImg(container: any, options: any) {
            const val = options.data && options.data.Imagine;
            const src = val ? `data:image/jpeg;base64,${val}` : null;
            const el = document.createElement('div');
            el.style.textAlign = 'center';
            el.innerHTML = src
                ? `<img src="${src}" style="max-width:72px;max-height:40px;border-radius:4px;display:block;margin:auto;" />`
                : `<span style="opacity:.5;">—</span>`;
            container.appendChild(el);
        },

        imageUploaderTemplate(data: any, itemElement: any) {
            const form = data.component;
            const fd = form.option('formData') || {};
            if (form.option('formData') == null) form.option('formData', fd);
            const wrap = document.createElement('div');
            wrap.innerHTML = `<input type="file" accept="image/*" />`;
            itemElement.appendChild(wrap);
            const input = wrap.querySelector('input') as HTMLInputElement;
            input.onchange = (e: Event) => {
                const target = e.target as HTMLInputElement;
                const file = target.files?.[0];
                if (!file || !file.type.startsWith('image/') || file.size > 5 * 1024 * 1024) return;
                const reader = new FileReader();
                reader.onload = (ev) => {
                    const dataUrl = String(ev.target?.result || '');
                    const base64 = dataUrl.split(',')[1] || '';
                    form.updateData('Imagine', base64);
                };
                reader.readAsDataURL(file);
            };
        },

        onContextMenuPreparing(e: any) {
            if (e.target === 'content' && e.row && e.row.rowType === 'data') {
                e.items = e.items || [];
                e.items.unshift({
                    text: 'Deschide produs',
                    icon: 'eyeopen',
                    onItemClick: () => {
                        if (e?.row?.data) this.onOpenProduct(e.row.data);
                    },
                });
            }
        },

        serviciuSetCellValue(newData: any, value: any) {
            newData.Serviciu = value;
            newData.Stocabil = value ? false : true;
        },

        goBackToClase() {
            const clasaID = this.$route.query.ClasaID as string;
            const categorieID = this.$route.query.CategorieId as string;
            this.$router.push({ name: 'Clase', params: { id: clasaID }, query: { CategorieId: categorieID } });
        },

        async openAddProduct() {
            const sp = this.selectorPopup;
            sp.selectedClasaId = null;
            sp.selectedCategorieId = null;
            sp.selectedCategorie = null;
            sp.categoriiForClasa = [];
            sp.clasaFilter = '';
            sp.visible = true;
            if (sp.clasaList.length === 0) {
                try {
                    const res = await fetch(
                        AppSetting.API_Url_ComercialOdata + 'PRO_Clase?$select=ID,NumeArborescent&$orderby=NumeArborescent',
                        { headers: { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') } }
                    );
                    const json = await res.json();
                    sp.clasaList = json.value || [];
                } catch {
                    notify('Eroare la încărcarea claselor.', 'error', 3000);
                }
            }
        },

        async onSelectorClasaClick(clasaId: string) {
            const sp = this.selectorPopup;
            if (sp.selectedClasaId === clasaId) return;
            sp.selectedClasaId = clasaId;
            sp.selectedCategorieId = null;
            sp.selectedCategorie = null;
            sp.categoriiForClasa = [];
            sp.isLoadingCategorii = true;
            try {
                const res = await fetch(
                    AppSetting.API_Url_ComercialOdata + `PRO_Categorii?$filter=ClasaId eq ${clasaId}&$select=Id,Cod,Nume,CategorieContabilaDefaultId&$orderby=Cod`,
                    { headers: { Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt') } }
                );
                const json = await res.json();
                sp.categoriiForClasa = json.value || [];
            } catch {
                notify('Eroare la încărcarea categoriilor.', 'error', 3000);
            } finally {
                sp.isLoadingCategorii = false;
            }
        },

        confirmSelectorCategorie() {
            const cat = this.selectorPopup.selectedCategorie;
            if (!cat) return;
            Object.assign(this.newProductData, {
                Cod: '', Nume: '', CategorieId: cat.Id,
                UnitateId: '31FD11E4-19B7-46E0-BBD5-204595349595',
                Activ: true, Serviciu: false, Stocabil: true, SeCantareste: false,
                Pret: 0, PretVanzare: 0,
                PretValutaId: '0A61647E-7391-4087-BC01-8EB9C2CEDEDD',
                TvaCurent: 19, TvaCurentData: new Date(),
                GarantieLuni: 12,
                CategorieContabilaId: cat.CategorieContabilaDefaultId || '119E7784-3247-409C-AA8B-BB5D5D4A6AE5',
                Imagine: null,
            });
            this.selectorPopup.visible = false;
            this.isAddProductVisible = true;
        },

        async saveNewProduct() {
            if (!this.newProductData.Nume || !this.newProductData.Nume.trim()) {
                notify('Denumirea produsului este obligatorie.', 'warning', 3000);
                return;
            }
            try {
                await (this.dsProduse as any).store().insert(this.newProductData);
                this.isAddProductVisible = false;
                (this.$refs.dataGrid as any)?.instance?.refresh();
                notify('Produsul a fost adăugat cu succes.', 'success', 2000);
            } catch (e: any) {
                notify(e?.message || 'Eroare la adăugarea produsului.', 'error', 4000);
            }
        },

        onSelectorHide() {
            this.selectorPopup.visible = false;
        },

        onJurnalHide() {
            this.jurnalPopup.visible = false;
        },

        onServiciuAddChanged(e: any) {
            if (e.value) this.newProductData.Stocabil = false;
            else this.newProductData.Stocabil = true;
        },

        onAddImageChange(event: Event) {
            const input = event.target as HTMLInputElement;
            const file = input.files?.[0];
            if (!file) return;
            if (!file.type.startsWith('image/')) { notify('Selectează o imagine.', 'error', 2000); return; }
            if (file.size > 5 * 1024 * 1024) { notify('Fișier prea mare (max 5 MB).', 'error', 2000); return; }
            const reader = new FileReader();
            reader.onload = (ev) => {
                const dataUrl = String(ev.target?.result || '');
                const comma = dataUrl.indexOf(',');
                this.newProductData.Imagine = comma >= 0 ? dataUrl.substring(comma + 1) : dataUrl;
            };
            reader.readAsDataURL(file);
        },

        onExporting(e: any) {
            if (e.format === 'pdf') {
                const doc = new jsPDF();
                exportDataGridPdf({ jsPDFDocument: doc, component: e.component, indent: 5 }).then(() => {
                    doc.save('Produse.pdf');
                });
            } else if (e.format === 'xlsx') {
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('produse');
                exportDataGridExcel({ component: e.component, worksheet, autoFilterEnabled: true }).then(() => {
                    workbook.xlsx.writeBuffer().then((buffer: any) => {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Produse.xlsx');
                    });
                });
                e.cancel = true;
            }
        },
    },
});
</script>

<style scoped>
.produse-view {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f8f9fc;
}

/* Tabs */
.tab-label {
  display: flex;
  align-items: center;
  gap: 6px;
}
.tab-close-btn {
  font-size: 16px;
  line-height: 1;
  color: #94a3b8;
  padding: 0 2px;
  border-radius: 3px;
  cursor: pointer;
}
.tab-close-btn:hover {
  color: #ef4444;
  background: #fee2e2;
}

.produse-view :deep(.dx-tabs) {
  margin-bottom: 10px;
}

.produse-view :deep(.dx-data-row td) {
  padding-top: 4px;
  padding-bottom: 4px;
}

.tab-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Page header (grid tab) */
.page-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 20px 10px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
}
.page-header-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: linear-gradient(135deg, #ff2c21, #ff6a4a);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.page-header-icon .dx-icon {
  color: #fff;
  font-size: 22px;
}
.page-header-title {
  font-size: 17px;
  font-weight: 700;
  color: #1e293b;
}
.page-header-subtitle {
  font-size: 12px;
  color: #94a3b8;
}

/* Status chip in grid */
.chip-activ {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: #ecfdf5;
  color: #065f46;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.chip-inactiv {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

/* Product detail tab */
.produs-tab-content {
  overflow-y: auto;
}

/* Product header */
.produs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  flex-shrink: 0;
}
.produs-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.produs-header-icon {
  width: 46px;
  height: 46px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.produs-header-icon .dx-icon {
  color: #fff;
  font-size: 24px;
}
.produs-header-name {
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  max-width: 500px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.produs-header-chips {
  display: flex;
  gap: 6px;
  margin-top: 5px;
  flex-wrap: wrap;
}
.pchip {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.pchip-code { background: rgba(255,255,255,0.2); color: #fff; }
.pchip-intern { background: rgba(255,255,255,0.15); color: rgba(255,255,255,0.9); }
.pchip-activ { background: #ecfdf5; color: #065f46; }
.pchip-inactiv { background: #f1f5f9; color: #475569; }
.pchip-serviciu { background: #eff6ff; color: #1d4ed8; }
.pchip-stocabil { background: #fef3c7; color: #92400e; }
.produs-header-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.produs-header-actions :deep(.header-btn-save.dx-button) {
  border-color: rgba(255, 255, 255, 0.85);
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
}
.produs-header-actions :deep(.header-btn-save.dx-button:hover) {
  background: rgba(255, 255, 255, 0.28);
}
.produs-header-actions :deep(.header-btn-save .dx-icon),
.produs-header-actions :deep(.header-btn-save .dx-button-text) {
  color: #fff;
}
.produs-header-actions :deep(.header-btn-cancel.dx-button) {
  border-color: rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.85);
  background: transparent;
}
.produs-header-actions :deep(.header-btn-cancel.dx-button:hover) {
  background: rgba(255, 255, 255, 0.12);
}
.produs-header-actions :deep(.header-btn-cancel .dx-icon),
.produs-header-actions :deep(.header-btn-cancel .dx-button-text) {
  color: rgba(255, 255, 255, 0.85);
}

/* Cards grid */
.produs-cards-scroll {
  overflow-y: auto;
  flex: 1;
  padding: 16px;
}
.produs-cards-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
}
.produs-card-span2 {
  grid-column: span 2;
}
.produs-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
  overflow: hidden;
}
.produs-card-full {
  grid-column: 1 / -1;
}

/* Card header */
.pcard-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  background: #fcfcfd;
  border-bottom: 1px solid #f1f5f9;
}
.pcard-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pcard-icon .dx-icon {
  color: #fff;
  font-size: 18px;
}
.pcard-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}
.pcard-subtitle {
  font-size: 11px;
  color: #94a3b8;
}

/* Card body */
.pcard-body {
  padding: 14px 16px;
}

/* Fields layout */
.pfields-row {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.pfields-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.pfield {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 160px;
  flex: 1;
}
.pfield-wide {
  flex: 2;
  min-width: 280px;
}
.pfield-full {
  flex-basis: 100%;
  flex-shrink: 0;
}
.pfield-label, label.pfield-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Switches row */
.pfields-switches {
  display: flex;
  gap: 24px;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  flex-wrap: wrap;
}
.pfield-switch {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #334155;
  font-weight: 500;
}

/* Image section */
.imagine-section {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}
.imagine-container {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-top: 8px;
}
.imagine-preview img {
  max-width: 120px;
  max-height: 100px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  object-fit: contain;
}
.imagine-placeholder {
  width: 120px;
  height: 80px;
  border-radius: 8px;
  border: 1px dashed #d1d5db;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: #94a3b8;
  font-size: 12px;
}
.imagine-placeholder .dx-icon { font-size: 24px; }
.imagine-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.imagine-upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 6px;
  border: 1px solid #d1d5db;
  background: #f8f9fc;
  font-size: 13px;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s;
}
.imagine-upload-btn:hover { background: #f1f5f9; }
.imagine-upload-btn input { display: none; }

/* ── Popup header (gradient, same as GridTabParteneriComercial) ─── */
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 18px;
  background: linear-gradient(90deg, #ff2c21, #ff6a4a);
  color: #fff;
}
.popup-header-main {
  display: flex;
  align-items: center;
  gap: 10px;
}
.popup-header-icon {
  font-size: 20px;
}
.popup-header-texts {
  display: flex;
  flex-direction: column;
}
.popup-header-title {
  font-size: 15px;
  font-weight: 700;
}
.popup-header-subtitle {
  font-size: 12px;
  opacity: 0.85;
}
.popup-header-meta {
  display: flex;
  align-items: center;
}
.status-chip {
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.7);
}
.status-chip--draft,
.status-chip--config {
  background-color: rgba(255, 255, 255, 0.18);
}
.popup-body-modern {
  padding: 0;
  height: 100%;
  overflow-y: auto;
}

/* ── Jurnal Cod Intern popup ─────────────────────────────── */
.jurnal-popup-body {
  padding: 16px 20px 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.jp-field {
  display: flex;
  align-items: center;
  gap: 10px;
}
.jp-label {
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  flex: 1;
  min-width: 210px;
}
.jp-switch-row {
  gap: 10px;
}
.jp-switch-label {
  font-size: 13px;
  color: #334155;
  font-weight: 500;
}
.jp-curent-box {
  margin-top: 4px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #f8fafc;
  padding: 10px 14px;
}
.jp-curent-inner {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.jp-curent-text {
  font-size: 12px;
  color: #475569;
  flex: 1;
}
.jp-curent-value {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  min-width: 60px;
}
.jp-exemplu {
  margin-top: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #fff7ed, #fffbeb);
  border: 1px solid #fed7aa;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.jp-exemplu-label {
  font-size: 12px;
  font-weight: 600;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  flex-shrink: 0;
}
.jp-exemplu-value {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  font-family: monospace;
  letter-spacing: 1px;
  word-break: break-all;
}
.jp-footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #f1f5f9;
  margin-top: 4px;
}
.jp-loading {
  padding: 32px;
  text-align: center;
  color: #94a3b8;
}

/* ── Selector popup (Clasă + Categorie) ─────────────────── */
.popup-body-modern.sel-popup-body {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.sel-layout {
  flex: 1;
  display: flex;
  min-height: 0;
}
.sel-left {
  width: 310px;
  flex-shrink: 0;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  min-height: 0;
}
.sel-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  min-height: 0;
}
.sel-panel-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-bottom: 6px;
  border-bottom: 2px solid #ff2c21;
  flex-shrink: 0;
}
.sel-ph-icon {
  font-size: 15px;
  color: #ff2c21;
}
.sel-panel-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  flex: 1;
}
.sel-badge {
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 10px;
}
.sel-list {
  flex: 1;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  background: #fafafa;
  min-height: 0;
}
.sel-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s;
}
.sel-item:last-child { border-bottom: none; }
.sel-item:hover { background: #f8fafc; }
.sel-item--active {
  background: #fff7f7 !important;
  border-left: 3px solid #ff2c21;
  padding-left: 9px;
}
.sel-item-icon {
  font-size: 14px;
  color: #94a3b8;
  flex-shrink: 0;
}
.sel-item--active .sel-item-icon { color: #ff2c21; }
.sel-item-text {
  font-size: 12.5px;
  color: #334155;
  line-height: 1.3;
}
.sel-item--active .sel-item-text { color: #1e293b; font-weight: 600; }
.sel-cat-item { flex-direction: column; align-items: flex-start; gap: 1px; }
.sel-cat-cod {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.sel-cat-nume { font-size: 13px; color: #334155; }
.sel-item--active .sel-cat-cod { color: #ef4444; }
.sel-item--active .sel-cat-nume { color: #1e293b; font-weight: 600; }
.sel-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 60px;
  gap: 6px;
  color: #94a3b8;
  font-size: 13px;
  padding: 16px;
  text-align: center;
}
.sel-empty--hint { gap: 10px; }
.sel-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
  flex-shrink: 0;
  gap: 12px;
}
.sel-selection-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #334155;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
}
.sel-selection-info span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ── Add product popup layout ───────────────────────────── */
/* .popup-body-modern scrolls (height:100%; overflow-y:auto already set).
   Grid grows to natural height; footer sticks via sticky. */
.add-popup-grid {
  padding: 14px 16px 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  align-content: start;
}
.field-req {
  color: #ef4444;
  margin-left: 2px;
}

/* ── Add product button (round green) ───────────────────── */
:deep(.btn-add-round.dx-button) {
  border-radius: 50% !important;
  min-width: unset;
}
:deep(.btn-add-round .dx-button-content) {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
}

.add-product-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #f1f5f9;
  background: #fff;
  position: sticky;
  bottom: 0;
}
.add-imagine-section {
  padding: 4px 0;
}
.add-imagine-label {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: block;
  margin-bottom: 8px;
}
.add-imagine-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.add-imagine-preview img {
  max-width: 80px;
  max-height: 60px;
  border-radius: 6px;
  border: 1px solid #e5e7eb;
  object-fit: contain;
}
:deep(.dx-scrollbar-horizontal .dx-scrollable-scroll),
:deep(.dx-scrollbar-vertical .dx-scrollable-scroll) {
  background: rgba(255, 87, 34, 0.55);
  border-radius: 4px;
}
:deep(.dx-scrollbar-horizontal) {
  height: 8px !important;
}
:deep(.dx-scrollbar-vertical) {
  width: 8px !important;
}
:deep(.dx-scrollbar-horizontal .dx-scrollable-scroll:hover),
:deep(.dx-scrollbar-vertical .dx-scrollable-scroll:hover) {
  background: rgba(255, 87, 34, 0.85);
}
</style>
